/* eslint-disable import/no-unresolved */
import AuditLogsColumnConfig from 'views/Rules/common/AuditLogsColumnConfig';
import AduitLog from '../components/AduitLog';

const AduitLogs = ({ data }) => {
    const fry7qColumns = AuditLogsColumnConfig;

    return (
        <AduitLog
            data={data}
            columns={fry7qColumns}
        />
    );
};

export default AduitLogs;
